import ButtonGsfurn from "components/General/ButtonGsfurn/ButtonGsfurn";
import Link from "next/link";

const ErrorMessage = ({
  title = "Oeps!",
  message = "Er ging iets mis! Probeer het nog eens! ",
  settings = {},
  reset = null,
}) => {
  return (
    <section className="bg-transparent">
      <div className="px-4 py-20 mx-auto mb-16 overflow-hidden xl:px-0 max-w-app">
        <div className="flex flex-col items-center">
          {title && <h1 className={settings?.titleClassName}>{title}</h1>}
          {message && (
            <p className={settings?.messageClassName || "mb-6"}>{message}</p>
          )}

          {reset ? (
            <ButtonGsfurn
              color="yellow_grw"
              size="xl"
              onClick={reset}
            >
              Probeer het opnieuw
            </ButtonGsfurn>
          ) : (
            <Link
              href="/"
              title="home"
              className="no-underline"
            >
              <ButtonGsfurn
                color="yellow_grw"
                size="xl"
              >
                Terug naar home
              </ButtonGsfurn>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default ErrorMessage;
